/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent').default);
////////////////// ADMINISTRACIÓN
//// USUARIOS
Vue.component('tableusers-component', require('./app/Administracion/Usuarios/tableUsers').default); // table data
Vue.component('modalnewuser-component', require('./app/Administracion/Usuarios/newUser').default); // modal new user
Vue.component('modaleditser-component', require('./app/Administracion/Usuarios/editUser').default); // edit user
//// PERMISOS
Vue.component('permisos-component', require('./app/Administracion/Permisos/permisosUsuarios').default); // permisos moët app web
//// MODULOS
Vue.component('modulos-component', require('./app/Administracion/Modulos/modulos').default); // show modules app Atenea
//// REPORTE RUTAS
Vue.component('reporterutas-component', require('./app/Administracion/ReporteRutas/report').default); // Reporte Rutas
//// ADMINISTRACIÓN TIENDAS
Vue.component('tiendasadmin-component', require('./app/Administracion/Tiendas/admtiendas').default); // Administración Tiendas
Vue.component('tiendas-component', require('./app/Administracion/Tiendas/tiendas').default); // Acciones Tiendas
Vue.component('cancadfmt-component', require('./app/Administracion/Tiendas/canalcadenaformato').default); // Acciones CANALES CADENAS FORMATOS
Vue.component('ciudades-component', require('./app/Administracion/Tiendas/ciudades').default); // Acciones CIUDADES
//// ADMINISTRACIÓN MAIN
Vue.component('mainr-component', require('./app/Administracion/Main/mainr').default); // Acciones main
//// ADMINISTRACIÓN PRODUCTOS
Vue.component('productos-component', require('./app/Administracion/Productos/productos.vue').default); // Acciones de administración de productos
//Vue.component('productostable-component', require('./app/Administracion/Productos/tableptos').default); // Tabla and admin de productos
//Vue.component('catalogospto-component', require('./app/Administracion/Productos/catalogos').default); // Administración de catálogos moet
/////////////////////Administración permisos rol aplicación
Vue.component('usrperapp-component', require('./app/Administracion/PermisosAplicacion/UsuariosPermisosAplicacion').default);//permisos para los usuario en la aplicación moet
////////////////// FINALIZA ADMINISTRACIÓN
////////////////// INICIA ENCUESTAS
Vue.component('crear-encuestas', require('./app/Encuestas/crearEncuesta').default); // Crear Encuestas
Vue.component('tabs-encuestas', require('./app/Encuestas/pasos/encuestasTabs').default); // TABS Encuestas
Vue.component('tabscrear-encuestas', require('./app/Encuestas/pasos/crearEncuesta').default); // Crear Encuestas
Vue.component('tabsload-encuestas', require('./app/Encuestas/pasos/loadEncuestas').default); // Cargar Encuestas
Vue.component('autorizar-encuestas', require('./app/Encuestas/aturizarEncuesstas').default); // Autorizar Encuestas
Vue.component('tabla-encuestas', require('./app/Encuestas/tabla').default); // Tabla de Encuestas
Vue.component('reporte-encuestas', require('./app/Encuestas/estadisticas/reporte').default); // Reporte de Encuestas estadisticas
////////////////// FINALIZA ENCUESTAS
////////////////// INICIA ANAQUEL
Vue.component('tabla-anaquel', require('./app/Anaquel/tabla').default); // Tabla de Anaquel
////////////////// FINALIZA ANAQUEL
////////////////// INICIA FALTANTES
Vue.component('faltantessemaforo-component', require('./app/Faltantes/semaforo').default); // Semaforo Faltantes
Vue.component('tabla-faltantes', require('./app/Faltantes/tabla').default); // Tabla de Faltantes
Vue.component('tabla-faltantes-tienda', require('./app/Faltantes/tablaTienda').default); // Tabla de Faltantes por tienda
////////////////// FINALIZA FALTANTES
////////////////// INICIA PROMOCIONES
Vue.component('tabla-promociones', require('./app/Promociones/tabla').default); // Tabla de Promociones
////////////////// FINALIZA PROMOCIONES
////////////////// INICIA PRECIOS
Vue.component('tabla-precios', require('./app/Precios/tabla').default); // Tabla de Precios
Vue.component('tabla-precios-categoria', require('./app/Precios/tablaCategoria.vue').default); // Tabla de Precios
Vue.component('tabla-precios-mayoreo', require('./app/Precios/tablaMayoreo').default); // Tabla de Precios Mayoreo
////////////////// FINALIZA PRECIOS
//////////////// INICIA EXHIBICIONES
Vue.component('tabla-exhibiciones', require('./app/Exhibiciones/tabla').default); // Tabla de Exhibiciones
////////////////// FINALIZA EXHIBICIONES

//////////////// INICIA DETALLE DE INFORMACIÓN
Vue.component('tabla-resumen-informacion', require('./app/DetalleInformacion/tablaResumen').default); // Tabla de Resumen de información
Vue.component('tabla-dashboard-informacion', require('./app/DetalleInformacion/dashboardEfectividad').default); // Tabla de Dashboard de información
Vue.component('tabla-detalle-informacion', require('./app/DetalleInformacion/detalleInformacion').default); // Tabla de detalle de información
////////////////// FINALIZA DETALLE DE INFORMACIÓN

////////////////// INICIA REPORTE GRAFICO
/////// IMAGENES
Vue.component('reporte-grafico', require('./app/ReporteGrafico/Galeria/galeria').default); // muestra las imagenes registradas en el sistema
Vue.component('tipo-galeria', require('./app/ReporteGrafico/Galeria/tipoGaleria').default); // componente que muta de acuero al tipo de galeria a consultar
/////// Tabla
Vue.component('tabla-reportegrafico', require('./app/ReporteGrafico/tabla').default); // Muestra la tabla de resmen de captura
Vue.component('tabla-reportegrafico-centros-consumo', require('./app/ReporteGrafico/tablaCentrosConsumo.vue').default); // Muestra la tabla de resmen de captura de los centros de consumo
////////////////// FINALIZA REPORTE GRAFICO
////////////////// INICIA ACTIVIDADES
////////////////// INICIA ACTIVIDADES
////////////Inventario
Vue.component('inventario-registro', require('./app/Actividad/Inventario/register').default); // registro de inventario en página web
Vue.component('inventario-reporte', require('./app/Actividad/Inventario/reporte').default); // reporte de inventario en página web
Vue.component('inventario-categorias', require('./app/Actividad/Inventario/reporteCategorias').default); // dashboard corporativo inventario por categorías
////////////Ventas
Vue.component('ventas-registro', require('./app/Actividad/Ventas/register').default); // registro de ventas en página web
Vue.component('ventas-reporte', require('./app/Actividad/Ventas/reporte').default); // reporte de ventas en página web
////////////Resurtido
Vue.component('resurtidos-registro', require('./app/Actividad/Resurtidos/register').default); // registro de resurtidos en página web
Vue.component('resurtidos-reporte', require('./app/Actividad/Resurtidos/reporte').default); // reporte de resurtidos en página web
////////////////// FINALIZA ACTIVIDADES

////////////////// COMPONENTES GLOBALES PARA MOËT
Vue.component('load-txtapp', require('./app/Administracion/loadtxt').default); // carga el archivo txt para validar las pruebas del envio de datos
Vue.component('filtrosreporterutas-component', require('./components/FilterReporteRutas').default); // Filtros para atenea Reporte Rutas!
Vue.component('filtrosreportecentroconsumos-component', require('./components/FilterReporteCentrosConsumo').default); // Filtros para atenea Reporte Rutas!
Vue.component('filtrossemaforofaltantes-component', require('./components/FilterSemaforoFaltantes').default); // Filtros para atenea Semaforo Faltantes!
Vue.component('keyboard-events', require('./components/EventsKeyUp').default); // Eventos de key up en el documento!
Vue.component('gestores-component', require('./components/generales/gestores').default); // Gestores de MOËT
Vue.component('tiposgestores-component', require('./components/generales/tipogestores').default); // Tipos Gestores de MOËT
Vue.component('chosenrolsupervisor-component', require('./components/generales/chosenRolSupervisor.vue').default); // get choseen roles moët
Vue.component('cadenas-component', require('./components/generales/cadenas').default); // Cadenas de MOËT
Vue.component('formatos-component', require('./components/generales/formatos').default); // Formatos de MOËT
Vue.component('tiendasmain-component', require('./components/generales/tiendas').default); // Tiendas de MOËT requiere formato
Vue.component('tiendas-select', require('./components/generales/tiendasGeneral').default); // Tiendas de MOËT completas sin filtros
Vue.component('fabricantes-select', require('./components/generales/fabricantes').default); // Fabricantes de MOËT
Vue.component('departamentos-select', require('./components/generales/departamentos').default); // Departamentos de MOËT
Vue.component('marcas-select', require('./components/generales/marcas').default); // Marcas de MOËT
Vue.component('categorias-select', require('./components/generales/categorias').default); // Categorias de MOËT
Vue.component('productos-select', require('./components/generales/productos').default); // Productos de MOËT
Vue.component('download-app', require('./components/generales/downloadapp').default); // Descarga app movil de MOËT
Vue.component('select-encuesta', require('./components/generales/encuestas').default); // Dfiltro para encuestas
////////////////// FINALIZA COMPONENTES GLOBALES PARA MOËT
////////////////// INICIA FILTROS GLOBALES PARA ATENEA CON TEXTOS
Vue.component('select-areasN', require('./components/filters/areas').default); // filtro para agencias nuevo con texto
Vue.component('select-agenciasN', require('./components/filters/agencias').default); // filtro para agencias nuevo con texto
Vue.component('select-estadosN', require('./components/filters/estados').default); // filtro para estados nuevo con texto
Vue.component('select-ciudadesN', require('./components/filters/ciudades').default); // filtro para estados nuevo con texto
Vue.component('select-canalesN', require('./components/filters/canal').default); // filtro para estados nuevo con texto
Vue.component('select-canalesNM', require('./components/filters/canalM').default); // filtro para estados nuevo con texto
Vue.component('select-cadenasN', require('./components/filters/cadenas').default); // filtro para estados nuevo con texto
Vue.component('select-formatosN', require('./components/filters/formatos').default); // filtro para estados nuevo con texto
Vue.component('select-tiendasN', require('./components/filters/tiendas').default); // filtro para estados nuevo con texto
Vue.component('select-departamentosN', require('./components/filters/departamentos').default); // filtro para estados nuevo con texto
Vue.component('select-categoriasN', require('./components/filters/categorias').default); // filtro para estados nuevo con texto
Vue.component('select-categoriasShare', require('./components/filters/categoriasShare').default); // filtro para estados nuevo con texto
Vue.component('select-promotoresN', require('./components/filters/promotores').default); // filtro para estados nuevo con texto
Vue.component('select-fabricantesN', require('./components/filters/fabricantes').default); // filtro para estados nuevo con texto
Vue.component('select-marcasN', require('./components/filters/marcas').default); // filtro para estados nuevo con texto
Vue.component('select-productosN', require('./components/filters/productos').default); // filtro para estados nuevo con texto
Vue.component('select-tradesN', require('./components/filters/trades').default); // filtro para estados nuevo con texto
Vue.component('select-texhibicionN', require('./components/filters/tipoExhibicion').default); // filtro para estados nuevo con texto
Vue.component('select-promocionN', require('./components/filters/tipoPromocion').default); // filtro para estados nuevo con texto
Vue.component('filters-general', require('./components/filters/filtrosGeneral').default); // general para faltantes
Vue.component('filters-general-mayoreo', require('./components/filters/filtrosGeneralMayoreo').default); // general para faltantes
////////////////// FINALIZA FILTROS GLOBALES PARA ATENEA


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//// GLOGAL COMPONENTES
//VUE TABLES
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable,ServerTable);
//SWEET ALERT 2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
// VUE TOOLTIP
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);
//FORM WIZARD
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
Vue.use(VueFormWizard);
// VUELIDATE
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
// VUE MULTI SELECT
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
Vue.component('multiselect', Multiselect);
// VUE DATEPICKER
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
Vue.component('DatePicker', DatePicker);
//VUE NAV TABS
import VueTabs from 'vue-nav-tabs';
import 'vue-nav-tabs/themes/vue-tabs.css';
Vue.use(VueTabs);
import VueHighcharts from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import exportingData from 'highcharts/modules/export-data';
import loadDrillDown from 'highcharts/modules/drilldown';
import loadSolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts3D from 'highcharts/highcharts-3d';
import heatmap from 'highcharts/modules/heatmap';
import pyramid3d from 'highcharts/modules/pyramid3d';
import funnel from 'highcharts/modules/funnel';
import funnel3d from 'highcharts/modules/funnel3d';
import cylinder from 'highcharts/modules/cylinder';
import loadHighchartsMore from 'highcharts/highcharts-more';
import accesibility from 'highcharts/modules/accessibility';
loadDrillDown(Highcharts);
exportingInit(Highcharts);
exportingData(Highcharts);
Highcharts3D(Highcharts);
heatmap(Highcharts);
loadHighchartsMore(Highcharts);
loadSolidGauge(Highcharts);
funnel(Highcharts);
funnel3d(Highcharts);
cylinder(Highcharts);
pyramid3d(Highcharts);
accesibility(Highcharts);
Vue.use(VueHighcharts, { Highcharts });
/// v-select
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect);
// momment
Vue.use(require('vue-moment'));
/// zoom image
import VueZoomer from 'vue-zoomer';
Vue.use(VueZoomer);
//pretty checkbox
import PrettyCheckbox from 'pretty-checkbox-vue';
import 'pretty-checkbox/src/pretty-checkbox.scss';
Vue.use(PrettyCheckbox);
import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import axios from 'axios';
axios.defaults.headers.post['Authorization'] = Token.Token;

///////////////////////////////////////// --------------------> INICIA EL REGISTRO DE FUNCIONES GLOBALES
Vue.prototype.$toastMessage = function toastMessage(type, text, duration,position) {
    this.Toast = this.$swal.mixin({
        toast: true, position: position, timerProgressBar: true,
        showConfirmButton: false, timer: duration
    });
    this.Toast.fire({
        icon: type,
        title: text
    });
}
//// PETICIONES POST WEBSERVICES ATENEA
Vue.prototype.$peticionesApi = async function(url, vars) {
    try {
        const resData = await axios.post(url, {data: vars});
        return resData.data;
    }
    catch (error) {
        let mensaje = "", type = "";
        switch (error.response.status) {
            case 500:
                mensaje = `Error en la petición al servidor, enviar esta pantalla de error al area de IT. Url: ${url}`;
                type = "error";
                break
            case 403:
                mensaje = `Sesión finalizada, por favor inicie sesión nuevamente. :)`;
                type = "warning";
                break
            default:
                mensaje = `Error en la petición al servidor, enviar esta pantalla de error al area de IT. Url: ${url} <br> Estatus: ${error.response.status}`;
                type = "error";
        }
        this.$toastMessage(type, `Error: ${mensaje}`, 4000, 'center');
        if (error.response.status === 403) {
            setTimeout(window.location.href = "/login", 45000);
        }
        return null;
    }
}
//// PETICIONES POST WEBSERVICES ATENEA FILES UPLOAD
Vue.prototype.$peticionesApiFiles = async function(url, formdata) {
    try {
        const resData = await axios.post(url, formdata, {headers: {'Content-Type': 'multipart/form-data'}});
        return resData.data;
    } catch (error) {
        let mensaje = "", type = "";
        switch (error.response.status) {
            case 500:
                mensaje = `Error en la petición al servidor, enviar esta pantalla de error al area de IT. Url: ${url}`;
                type = "error";
                break
            case 403:
                mensaje = `Sesión finalizada, por favor inicie sesión nuevamente. :)`;
                type = "warning";
                break
            default:
                mensaje = `Error en la petición al servidor, enviar esta pantalla de error al area de IT. Url: ${url} <br> Estatus: ${error.response.status}`;
                type = "error";
        }
        this.$toastMessage(type, `Error: ${mensaje}`, 4000, 'center');
        if (error.response.status === 403) {
            setTimeout(window.location.href = "/login", 45000);
        }
        return [];
    }
}
//// PETICIONES POST WEBSERVICES ATENEA FILES DOWNLOAD
Vue.prototype.$peticionesApiFilesDownload = async function(url, nameFile, dataProccess) {
    try {
        await axios({
            method: 'post',
            url: url,
            responseType: 'arraybuffer',
            data: { data: dataProccess } }).then(r => {
            let blob = new Blob([r.data], { type: 'application/xlsx' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = nameFile
            link.click()
        });

    }
    catch (error) {
        let mensaje = "", type = "";
        switch (error.response.status) {
            case 500:
                mensaje = `Error en la petición al servidor, enviar esta pantalla de error al area de IT. Url: ${url}`;
                type = "error";
                break
            case 403:
                mensaje = `Sesión finalizada, por favor inicie sesión nuevamente. :)`;
                type = "warning";
                break
            default:
                mensaje = `Error en la petición al servidor, enviar esta pantalla de error al area de IT. Url: ${url} <br> Estatus: ${error.response.status}`;
                type = "error";
        }
        this.$toastMessage(type, `Error: ${mensaje}`, 4000, 'center');
        if (error.response.status === 403) {
            setTimeout(window.location.href = "/login", 45000);
        }
        return [];
    }
}
///////////////////////////////////////// --------------------> FINALIZA EL REGISTRO DE FUNCIONES GLOBALES

const app = new Vue({
    el: '#app',
});
